<groundworks-modal>
  <app-paginated-modal-header
    [title]="modalTitle()"
    [showNavigation]="!isLoading() && !hasError() && !!currentEntry()"
    [isFirst]="isFirst()"
    [isLast]="isLast()"
    (previous)="previous()"
    (next)="next()"
    (closed)="closeModal()"
  />
  <groundworks-modal-body>
    @if (isLoading()) {
      <groundworks-state-message
        data-testid="loading-state"
        type="loading"
        message="Loading change order history..."
      />
    }
    @if (hasError() && !isLoading()) {
      <groundworks-state-message
        data-testid="error-state"
        type="error"
        message="Failed to load change order history. Please try again."
        [button]="retryButton"
      />
    }
    @if (!isLoading() && !hasError() && currentEntry()) {
      <groundworks-term-value
        data-testid="summary-fields"
        [items]="summaryItems()"
      />

      @if (hasUpsellItems()) {
        <groundworks-card [title]="'Upsell'" [cardClasses]="['mt-3']" data-testid="upsell-section">
          <groundworks-card-body>
            <div data-testid="upsell-table">
              <groundworks-table [data]="upsellTableData()" />
            </div>
          </groundworks-card-body>
        </groundworks-card>
      }

      @if (hasDescopeItems()) {
        <groundworks-card [title]="'Descope'" [cardClasses]="['mt-3']" data-testid="descope-section">
          <groundworks-card-body>
            <div data-testid="descope-table">
              <groundworks-table [data]="descopeTableData()" />
            </div>
          </groundworks-card-body>
        </groundworks-card>
      }

      @if (hasTaxItems()) {
        <groundworks-card [title]="'Taxes'" [cardClasses]="['mt-3']" data-testid="taxes-section">
          <groundworks-card-body>
            <div data-testid="taxes-table">
              <groundworks-table [data]="taxesTableData()" />
            </div>
          </groundworks-card-body>
        </groundworks-card>
      }
    }
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions" />
</groundworks-modal>
